var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: [_vm.toastShow ? "on" : "", "sqToast"] }, [
    _c("div", { staticClass: "sq-wrapper" }, [
      _c("div", { staticClass: "content" }, [
        _c("i", {
          class: [_vm.toastFull ? "icon-bookmark-full" : "icon-bookmark"]
        }),
        _vm._v(" "),
        _c("div", { staticClass: "txt" }, [_vm._v(_vm._s(_vm.toastContent))])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cce9688", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cce9688","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/toast/favoritesToast.vue
// module id = null
// module chunks = 